import { VaBackgroundDetailsField } from "schemas/dashboard";

export const DefaultBackgroundQuestions = {
  personal_facts: {
    question:
      "Share 2-3 things about you that a brand might find interesting or useful for content.",
    answer: "",
    field_name: VaBackgroundDetailsField.personal_facts,
  },
  content_type: {
    question:
      "Do you work with brands on influencer partnerships, UGC, or both? If it's both, let us know whether you want pitches to focus on one or include both.",
    answer: "",
    field_name: VaBackgroundDetailsField.content_type,
  },
  content_tone: {
    question:
      "Share 2-3 words to describe the tone you'd like your pitch written in.",
    answer: "",
    field_name: VaBackgroundDetailsField.content_tone,
  },
  why_brands_like_your_content: {
    question:
      "Why do brands like your content? Share what you bring to the table.",
    answer: "",
    field_name: VaBackgroundDetailsField.why_brands_like_your_content,
  },
  biggest_brand_names: {
    question:
      "What are the biggest brand names you have partnered with in the past?",
    answer: "",
    field_name: VaBackgroundDetailsField.biggest_brand_names,
  },
  most_proud_partnerships: {
    question: "What past partnerships of yours are you most proud of and why?",
    answer: "",
    field_name: VaBackgroundDetailsField.most_proud_partnerships,
  },
  other: {
    question:
      "Anything else you would like to share? Share anything that would help us write unique and curated pitches for you.",
    answer: "",
    field_name: VaBackgroundDetailsField.other,
  },
};

export const TemplateBackgroundQuestions = {
  personal_facts: {
    question:
      "Share 2-3 things about you that a brand might find interesting or useful for content.",
    answer: "",
    field_name: VaBackgroundDetailsField.personal_facts,
  },
  why_brands_like_your_content: {
    question:
      "Why do brands like your content? Share what you bring to the table.",
    answer: "",
    field_name: VaBackgroundDetailsField.why_brands_like_your_content,
  },
  most_proud_partnerships: {
    question: "What past partnerships of yours are you most proud of and why?",
    answer: "",
    field_name: VaBackgroundDetailsField.most_proud_partnerships,
  },
  other: {
    question:
      "Anything else you would like to share? Share anything that would help us write unique and curated pitches for you.",
    answer: "",
    field_name: VaBackgroundDetailsField.other,
  },
};
